export default "__VITE_ASSET__Bka0y0lt__"